import Zones from "@/components/Zones/Zones";

const HeartRateZonesPage = () => {
  return <Zones type="heartRate" />;
};

export default HeartRateZonesPage;
